"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  colors: {
    black: '#000000',
    blue: '#177AD0',
    blueLight: '#EDF3FA',
    gray: '#767676',
    grayFaint: '#F5F5F5',
    grayLight: '#D6D6D6',
    grayMedium: '#A0A0A0',
    purple: '#9C48B3',
    teal: '#00A4A6',
    tealMidrange: '#09757A',
    white: '#FFFFFF'
  },
  fonts: {
    gdsage: "gd-sage,\"Times New Roman\", serif"
  },
  sizes: {
    search: 64
  }
};
exports.default = _default;